import { TableFilterApiBody } from '../types'
import { EntityState } from '../types/entity.types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { updateAuthUserSelectedTenant } from './auth.slice'
import {
  setEntitiesMapByIdCache,
  setEntitiesNameMapByTableNameCache,
} from '../utils/entities.utils'

const initialState: EntityState = {
  entities: [],
  bookmarkEntities: [],
  selected: null,
  entityId: null,
  entityName: null,
  entityData: null,
  paginatedEntities: [],
  loading: false,
  searchQuery: '',
  entitiesByName: {},
  entitiesMapById: {},
  entitiesNameMapByTableName: {},
}

const entitySlice = createSlice({
  name: 'entities',
  initialState: initialState,
  reducers: {
    updateEntities: (state, action) => {
      state.entities = action.payload
    },
    updateBookmarkEntities: (state, action) => {
      state.bookmarkEntities = action.payload
    },
    updateSelectedEntity: (state, action) => {
      state.selected = action.payload
    },
    updateSearchQuery: (state, action) => {
      state.searchQuery = action.payload
    },
    updateCreateEntity: (state, action) => {
      state.entityId = action.payload.id
    },
    updateLoader: (state, action) => {
      state.loading = action.payload
    },
    resetEntity: (state) => {
      state.entities = []
      state.entityId = null
      state.selected = null
    },
    getAllEntitiesAction: () => {
      return
    },
    getAllEntitiesPaginatedAction: (_state, _action) => {
      return
    },
    getAllEntitiesAgentAction: () => {
      return
    },
    updateGetAllEntitiesByPage: (state, action) => {
      state.paginatedEntities = action?.payload?.content
      state.totalRecords = action?.payload?.totalPages
    },
    getBookmarkedEntitesAction: () => {
      return
    },
    deleteEntityAction: (
      state,
      action: PayloadAction<{ entityId: string; page: number; size: string }>
    ) => {
      void action.payload
      return state
    },
    updateEntitiesByName: (state, action) => {
      state.entitiesByName = action.payload
    },
    updateEntitiesMapById: (state, action) => {
      state.entitiesMapById = action.payload
      setEntitiesMapByIdCache(action.payload)
    },
    updateEntitiesNameMapByTableName: (state, action) => {
      state.entitiesNameMapByTableName = action.payload
      setEntitiesNameMapByTableNameCache(action.payload)
    },
    toggleEntityAction: (
      state,
      action: PayloadAction<{
        entityId: string
        status: boolean
        filter?: TableFilterApiBody
        page?: number
        size?: string
        sort?: string
        includeSourceTypes?: string
      }>
    ) => {
      void action.payload
      return state
    },
    updateAction: (state, action) => {
      void action
      return state
    },
    updateEntityName: (
      state,
      action: PayloadAction<{ entityName: string }>
    ) => {
      state.entityName = action.payload.entityName
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAuthUserSelectedTenant, (state) => {
      state.entities = []
      state.bookmarkEntities = []
      state.entitiesByName = {}
      state.entitiesMapById = {}
      setEntitiesMapByIdCache({})
      state.entitiesNameMapByTableName = {}
      setEntitiesNameMapByTableNameCache({})
    })
  },
})

export const {
  updateEntities,
  updateSelectedEntity,
  getBookmarkedEntitesAction,
  updateCreateEntity,
  resetEntity,
  getAllEntitiesAction,
  updateGetAllEntitiesByPage,
  getAllEntitiesPaginatedAction,
  deleteEntityAction,
  updateBookmarkEntities,
  toggleEntityAction,
  updateAction,
  updateEntityName,
  getAllEntitiesAgentAction,
  updateLoader,
  updateSearchQuery,
  updateEntitiesByName,
  updateEntitiesMapById,
  updateEntitiesNameMapByTableName,
} = entitySlice.actions
export default entitySlice.reducer
